export class User{
    username :string;
    passwordhash : string;
	email:string;
    constructor(username :string,
        passwordhash : string,
        email:string) {
            this.username = username;
            this.passwordhash =passwordhash;
            this.email=email;
    }
}